/* Copyright (c) 2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { theme } from "@nordcloud/gnui";

export const disabledStyle = (disabled = false) =>
  disabled
    ? {
        fill: theme.color.interactive.disabled,
        color: theme.color.interactive.disabled,
      }
    : {};
